import { render } from "./SimpleSwitch.vue?vue&type=template&id=0be6c117&scoped=true&ts=true"
import script from "./SimpleSwitch.vue?vue&type=script&lang=ts"
export * from "./SimpleSwitch.vue?vue&type=script&lang=ts"

import "./SimpleSwitch.vue?vue&type=style&index=0&id=0be6c117&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be6c117"]])

export default __exports__